export const etapeDemandeMap = {

    1: 'infos-detenu',

    2: 'recap-pieces-justif',

    3: 'choix-beneficiaire',

    4: 'infos-visiteur',

    5: 'infos-complementaires-visiteur',

    6: 'demande-mineur-emancipe',

    7: 'infos-majeur-rattache',

    8: 'lien-visiteur-detenu',

    9: 'pieces-justificatives/piece-jointe-lien-detenu',

    10: 'pieces-justificatives/piece-jointe-photo-identite',

    11: 'pieces-justificatives/piece-jointe-identite',

    12: 'pieces-justificatives/piece-jointe-justificatif-domicile',

    13: 'pieces-justificatives/piece-jointe-justificatif-personne-mineure',

    14: 'pieces-justificatives/piece-jointe-justificatif-complementaire-1',
    15: 'pieces-justificatives/piece-jointe-justificatif-complementaire-2',
    16: 'pieces-justificatives/piece-jointe-justificatif-complementaire-3',

    17: 'piece-jointe-informations-complementaires',

    18: 'confirmation-transmission-demande',

} as { [index: string]: string };
